import { Card, FormSkeleton, Skeleton, WizardPasoSkeleton } from "@/components/ui";

/**
 * Paso «Datos generales» en carga · marco del wizard + la tarjeta del formulario
 * con la forma de `DatosGeneralesForm` (motivo, periodo inicio/fin, área,
 * comentarios y la fila Regresar / Guardar y continuar). Es el `pendingComponent`
 * de la ruta.
 */
export function DatosGeneralesSkeleton() {
  return (
    <WizardPasoSkeleton>
      <Card padding="lg">
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-1.5">
            <Skeleton height={16} width="28%" />
            <Skeleton height={12} width="55%" />
          </div>
          <FormSkeleton campos={1} columnas={1} />
          <FormSkeleton campos={2} columnas={2} />
          <FormSkeleton campos={1} columnas={1} />
          <div className="flex flex-col gap-1.5">
            <Skeleton height={12} width="20%" />
            <Skeleton height={10} width="45%" />
            <Skeleton height={76} />
          </div>
          <div className="mt-1 flex justify-between gap-2">
            <Skeleton height={36} width={150} />
            <Skeleton height={36} width={170} />
          </div>
        </div>
      </Card>
    </WizardPasoSkeleton>
  );
}
